import { clearSelectedColumn, type ClearSelectedColumnAction } from './clear-selected-column';
import {
	removeDateValidationErrors,
	type RemoveDateValidationErrors,
} from './remove-date-validation-errors';
import { type ResetProjectDataAction, resetProjectData } from './reset-project-data';
import { resetState } from './reset-state';
import {
	resetStateAndReturnToUploadStep,
	type ResetStateAndReturnToUploadStepAction,
} from './reset-state-and-return-to-upload-step';
import { updateAdvancedOptions, type UpdateAdvancedOptionsAction } from './set-advanced-options';
import { setFieldForColumn, type SetFieldForColumnAction } from './set-field-for-column';
import { setImportType, type SetImportTypeAction } from './set-import-type';
import { setImportTypeAndStep, type SetImportTypeAndStepAction } from './set-import-type-and-step';
import {
	setIsIncludedForColumn,
	type SetIsIncludedForColumnAction,
} from './set-is-included-for-column';
import {
	setIsThirdPartyFieldIncluded,
	type SetIsThirdPartyFieldIncludedAction,
} from './set-is-third-party-field-included';
import { setIsVisibleForAll, type SetIsVisibleForAllAction } from './set-is-visible-for-all';
import {
	setIsVisibleForColumn,
	type SetIsVisibleForColumnAction,
} from './set-is-visible-for-column';
import { setMappingState, type SetMappingStateAction } from './set-mapping-state';
import {
	setMappingStateValidationError,
	type SetMappingStateValidationErrorAction,
} from './set-mapping-state-error';
import { setMigrationId, type SetMigrationIdAction } from './set-migration-id';
import {
	setNextSelectedColumn,
	type SetNextSelectedColumnAction,
} from './set-next-selected-column';
import {
	setNextSelectedUnmappedColumn,
	type SetNextSelectedUnmappedColumnAction,
} from './set-next-selected-unmapped-column';
import { setProjectData, type SetProjectDataAction } from './set-project-data';
import { setProjectType, type SetProjectTypeAction } from './set-project-type';
import { setSourceItems, type SetSourceItemsAction } from './set-source-items';
import { setStep, type SetStepAction } from './set-step';
import {
	setThirdPartyFieldMapping,
	type SetThirdPartyFieldMappingAction,
} from './set-third-party-field-mapping';
import { setThirdPartyState, type SetThirdPartyStateAction } from './set-third-party-state';
import {
	type SetThirdPartyImportSettingsAction,
	setThirdPartyImportSettings,
} from './set-third-party-state-import-settings';
import {
	setThirdPartyStateWithPreselectedEntityId,
	type SetThirdPartyStateWithPreselectedEntityIdAction,
} from './set-third-party-state-with-preselected-entity-id';
import {
	setThirdPartyStateWithPreselectedWorkspaceId,
	type SetThirdPartyStateWithPreselectedWorkspaceIdAction,
} from './set-third-party-state-with-preselected-workspace-id';
import {
	setThirdPartyStatusMapping,
	type SetThirdPartyStatusMappingAction,
} from './set-third-party-status-mapping';
import {
	setThirdPartyStatusOption,
	type SetThirdPartyStatusOptioAction,
} from './set-third-party-status-option';
import {
	setUnmappedColumnsNotIncluded,
	type SetUnmappedColumnsNotIncludedAction,
} from './set-unmapped-columns-not-included';
import {
	setUploadedConfigName,
	type SetUploadedConfigNameAction,
} from './set-uploaded-config-name';
import { setUploadedFileName, type SetUploadedFileNameAction } from './set-uploaded-filename';

export type Actions = {
	removeDateValidationErrors: RemoveDateValidationErrors;
	setMappingState: SetMappingStateAction;
	setMappingStateValidationError: SetMappingStateValidationErrorAction;
	setMigrationId: SetMigrationIdAction;
	setStep: SetStepAction;
	setUploadedFileName: SetUploadedFileNameAction;
	setUploadedConfigName: SetUploadedConfigNameAction;
	setIsVisibleForColumn: SetIsVisibleForColumnAction;
	setFieldForColumn: SetFieldForColumnAction;
	setIsVisibleForAll: SetIsVisibleForAllAction;
	updateAdvancedOptions: UpdateAdvancedOptionsAction;
	setProjectData: SetProjectDataAction;
	setProjectType: SetProjectTypeAction;
	resetProjectData: ResetProjectDataAction;
	setNextSelectedColumn: SetNextSelectedColumnAction;
	setNextSelectedUnmappedColumn: SetNextSelectedUnmappedColumnAction;
	clearSelectedColumn: ClearSelectedColumnAction;
	setImportType: SetImportTypeAction;
	setImportTypeAndStep: SetImportTypeAndStepAction;
	setThirdPartyState: SetThirdPartyStateAction;
	setThirdPartyImportSettings: SetThirdPartyImportSettingsAction;
	resetStateAndReturnToUploadStep: ResetStateAndReturnToUploadStepAction;
	setIsThirdPartyFieldIncluded: SetIsThirdPartyFieldIncludedAction;
	setThirdPartyFieldMapping: SetThirdPartyFieldMappingAction;
	setThirdPartyStateWithPreselectedWorkspaceId: SetThirdPartyStateWithPreselectedWorkspaceIdAction;
	setThirdPartyStateWithPreselectedEntityId: SetThirdPartyStateWithPreselectedEntityIdAction;
	setThirdPartyStatusMapping: SetThirdPartyStatusMappingAction;
	setThirdPartyStatusOption: SetThirdPartyStatusOptioAction;
	resetState: ResetStateAndReturnToUploadStepAction;
	setSourceItems: SetSourceItemsAction;
	setIsIncludedForColumn: SetIsIncludedForColumnAction;
	setUnmappedColumnsNotIncluded: SetUnmappedColumnsNotIncludedAction;
};

export const actions: Actions = {
	removeDateValidationErrors,
	setMappingState,
	setMappingStateValidationError,
	setMigrationId,
	setStep,
	setImportType,
	setUploadedFileName,
	setUploadedConfigName,
	setIsVisibleForColumn,
	setFieldForColumn,
	setIsVisibleForAll,
	updateAdvancedOptions,
	setProjectData,
	setProjectType,
	resetProjectData,
	setNextSelectedColumn,
	setNextSelectedUnmappedColumn,
	clearSelectedColumn,
	setImportTypeAndStep,
	setThirdPartyState,
	setThirdPartyImportSettings,
	resetStateAndReturnToUploadStep,
	setIsThirdPartyFieldIncluded,
	setThirdPartyFieldMapping,
	setThirdPartyStateWithPreselectedWorkspaceId,
	setThirdPartyStateWithPreselectedEntityId,
	setThirdPartyStatusMapping,
	setThirdPartyStatusOption,
	resetState,
	setSourceItems,
	setIsIncludedForColumn,
	setUnmappedColumnsNotIncluded,
};
